/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountSummaryRequest {
    getFixupPrototypeFunction() { return ServiceAccountSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountSummaryRequest>): ServiceAccountSummaryRequest {
        let obj = Object.assign(new ServiceAccountSummaryRequest(), model);
        ServiceAccountSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountSummaryRequest>): ServiceAccountSummaryRequest {
        if (!model) return null;
        return ServiceAccountSummaryRequest.newInstance(<ServiceAccountSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountSummaryRequest) {
        if (!obj) return;

        models.ServiceAccountSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountSummaryRequest): boolean {
        Object.setPrototypeOf(obj, ServiceAccountSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.ServiceAccountFilter.fixupPrototype(this.filters);
        }
    }

    /**
     * Filter for the service accounts
     */
    filters: models.ServiceAccountFilter;

}
